
import { css } from 'lit';
export default css`
pc-personal-quote [slot='image'] pc-image img{
  width:100%;
  aspect-ratio:1.6;
  height:100%;
}

pc-personal-quote [slot='content'] pc-detail{
  margin-bottom:var(--spacing-4);
  color:var(--purple-indigo);
  display:block;
}

pc-personal-quote [slot='content'] pc-heading{
  color:var(--primary-eggplant);
}

pc-personal-quote [slot='content'] pc-heading > *{
  display:-webkit-box;
  -webkit-line-clamp:5;
  -webkit-box-orient:vertical;
  overflow:hidden;
}

pc-personal-quote [slot='footer']{
  color:var(--primary-eggplant);
}

pc-personal-quote [slot='footer'] pc-caption{
  --pc-caption-color:var(--primary-eggplant);
}

pc-personal-quote[pc-hero-carousel] [slot='content'] pc-heading{
    color:var(--primary-white);
    text-transform:none;
    margin:var(--spacing-4) 0;
  }

pc-personal-quote[pc-hero-carousel] [slot='content'] pc-detail{
    color:var(--purple-indigo-light);
  }

pc-personal-quote[pc-hero-carousel] [slot='content'] pc-link{
    text-transform:none;
    margin:var(--spacing-4) 0;
  }

pc-personal-quote[pc-hero-carousel] [slot='content'] pc-link a.link--swipe-arrow{
      --link-border-color:var(--purple-indigo);
      --link-border-width:2px;
      color:var(--purple-indigo-light);
      font-size:var(--fs-body);
      text-decoration:none;
      --link-border-image:linear-gradient(
        transparent calc(100% - var(--link-border-width)),
        var(--link-border-color) var(--link-border-width)
      );
      transition:background-size 0.3s;
      background-image:var(--link-border-image);
      background-size:0 100%;
      background-repeat:no-repeat;
      padding-bottom:var(--spacing-1);
    }

pc-personal-quote[pc-hero-carousel] [slot='content'] pc-link a.link--swipe-arrow pc-icon{
      transition:all 0.3s ease 0s;
      display:inline-flex;
    }

pc-personal-quote[pc-hero-carousel] [slot='content'] pc-link a.link--swipe-arrow:hover pc-icon{
      transform:translateX(var(--spacing-1));
    }

pc-personal-quote[pc-hero-carousel] [slot='content'] pc-link a.link--swipe-arrow:hover, pc-personal-quote[pc-hero-carousel] [slot='content'] pc-link a.link--swipe-arrow:focus{
      background-size:calc(100% - 24px) 100%;
    }

@media (max-width: 767px){
  pc-personal-quote [slot='image'] pc-image img{
    max-height:221px;
  }
}

@media (max-width: 991px){
  pc-personal-quote [slot='image'] pc-image img{
    max-height:260px;
  }

  pc-personal-quote [slot='content'] pc-heading{
    --heading-font-size-mobile:var(--fs-h6-mobile);
    --heading-font-size:var(--fs-h6);
  }
}

@media (max-width: 1280px){
  pc-personal-quote [slot='content'] pc-heading{
    --heading-font-size:var(--fs-h6);
  }
}
`;